/**
 * Loading indicator
 */

const { Component } = wp.element;


export class Indicator extends Component {


  getStyleProps(  ) {
    const styles = {};
    if (this.props.minHeight) {
      styles.minHeight = this.props.minHeight + 'px';
    }
  }

  getSize() {
    return this.props.size || 128;
  }

  getPath() {
    return BootStrap.dir + '/images/spinner-128px.svg';
  }

  getAlt() {
    return '読み込み中……';
  }

  render() {
    return this.props.loading ? (
      <div className='paidmedia-indicator' style={this.getStyleProps()}>
        <span className='paidmedia-indicator-container'>
          <img className='paidmedia-indicator-image' src={this.getPath()} width={ this.getSize() } height={this.getSize()} alt={ this.getAlt() } />
          <br />
          <span className='paidmedia-indicator-text badge badge-secondary'>{ this.getAlt() }</span>
        </span>
      </div>
    ) : null;
  }
}
